import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import PartnersPage from './PartnersPage';
import CampaignsPage from './CampaignsPage';
import AnalyticsPage from './AnalyticsPage';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const GrowthHubLayout = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('partners');
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    checkAdminAccess();
  }, []);

  const checkAdminAccess = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/');
        return;
      }
      const { data } = await axios.get(`${API_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (data.role !== 'admin' && !['admin@mysticai.com', 'hak.dalmis@gmail.com', 'demo@mysticai.com', 'hakandalmis@paracini.com'].includes(data.email)) {
        alert('Admin yetkisi gerekli!');
        navigate('/');
        return;
      }
      setIsAdmin(true);
      setLoading(false);
    } catch (error) {
      console.error('Admin check error:', error);
      navigate('/');
    }
  };

  const tabs = [
    { id: 'partners', label: 'Partnerler', icon: '🏪' },
    { id: 'campaigns', label: 'Kampanyalar', icon: '🎯' },
    { id: 'analytics', label: 'Analitik', icon: '📊' },
  ];

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0d0d2b 0%, #1a0533 100%)',
        color: 'white'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚀</div>
          <h2>Büyüme Merkezi Yükleniyor...</h2>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #0d0d2b 0%, #1a0533 100%)',
      color: 'white'
    }}>
      {/* Header */}
      <div style={{
        background: 'rgba(255,255,255,0.05)',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button
            onClick={() => navigate('/admin')}
            style={{
              background: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.2)',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            ← Admin Panel
          </button>
          <h1 style={{ margin: 0, fontSize: '24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>🚀</span>
            <span>Büyüme Merkezi</span>
          </h1>
        </div>
        <div style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)' }}>
          Partner Büyüme Platformu v1.0
        </div>
      </div>

      {/* Tab Navigation - with hover transitions */}
      <div style={{
        display: 'flex',
        gap: '4px',
        padding: '16px 24px',
        background: 'rgba(0,0,0,0.2)',
        borderBottom: '1px solid rgba(255,255,255,0.05)'
      }}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            data-testid={`tab-${tab.id}`}
            style={{
              padding: '12px 24px',
              background: activeTab === tab.id 
                ? 'linear-gradient(135deg, rgba(139,92,246,0.3), rgba(99,102,241,0.3))'
                : 'rgba(255,255,255,0.05)',
              border: activeTab === tab.id 
                ? '1px solid rgba(139,92,246,0.5)'
                : '1px solid transparent',
              borderRadius: '10px',
              color: activeTab === tab.id ? 'white' : 'rgba(255,255,255,0.6)',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: activeTab === tab.id ? '600' : '500',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.25s ease'
            }}
            onMouseEnter={(e) => {
              if (activeTab !== tab.id) {
                e.currentTarget.style.background = 'rgba(139,92,246,0.15)';
                e.currentTarget.style.borderColor = 'rgba(139,92,246,0.3)';
                e.currentTarget.style.color = 'white';
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== tab.id) {
                e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                e.currentTarget.style.borderColor = 'transparent';
                e.currentTarget.style.color = 'rgba(255,255,255,0.6)';
              }
            }}
          >
            <span>{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div style={{ padding: '24px' }}>
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
        >
          {activeTab === 'partners' && <PartnersPage />}
          {activeTab === 'campaigns' && <CampaignsPage />}
          {activeTab === 'analytics' && <AnalyticsPage />}
        </motion.div>
      </div>
    </div>
  );
};

export default GrowthHubLayout;
